export default {
  en: {
    title: 'Page not found',
    description: 'Sorry, we couldn\'t find that page.',
  },
};
